import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=2463c898&"
import script from "./DeviceSettings.vue?vue&type=script&lang=js&"
export * from "./DeviceSettings.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2463c898')) {
      api.createRecord('2463c898', component.options)
    } else {
      api.reload('2463c898', component.options)
    }
    module.hot.accept("./DeviceSettings.vue?vue&type=template&id=2463c898&", function () {
      api.rerender('2463c898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/DeviceSettings.vue"
export default component.exports